import React from "react";

import { List, Avatar } from "antd";

const Comments = ({ record }) => {
    return (
        <List
            itemLayout="horizontal"
            dataSource={record.timeline || []}
            renderItem={(item) => (
                <List.Item key={item.id}>
                    <List.Item.Meta avatar={<Avatar>U</Avatar>} title={item.person} description={item.notes} />
                </List.Item>
            )}
        />
    );
};

export default Comments;
